import { Payload, TagsParamsResult } from '../types';
import { mapUserProps } from './mapUserProps';

export const mapTagsParams = (payload: Payload): TagsParamsResult => ({
    os_version: payload.osVersion,
    device_id: payload.deviceId,
    screen_resolution: payload.screenResolution,
    ...mapUserProps(payload),
});
